import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type CustomiseCheckBoxPacksList = 'subtitle' | 'container';

const customiseCheckboxPacksListStyles = makeStyles<ISpcTheme, CustomiseCheckBoxPacksList>(
  theme => ({
    subtitle: {
      color: theme.palette.text.secondary,
      position: 'relative',
      top: '-12px',
    },
    container: {
      width: '100%',
    },
  }),
  { name: 'Customise_CustomiseCheckBoxPacksList' },
);

export default customiseCheckboxPacksListStyles;
